import { appendUrlQuery } from '@core/utils'
import { SKY_EYE_SYSTEM_PATH } from '@constant'

export const INDEX_PATH = appendUrlQuery(SKY_EYE_SYSTEM_PATH, { tab: 2 })
export const POTENTIAL_CREATE_BATCH_PATH =
  SKY_EYE_SYSTEM_PATH + '/potentialCustomers/createPush'
export const POTENTIAL_INTRODUCE_PATH =
  SKY_EYE_SYSTEM_PATH + '/potentialCustomers/introduce'
export const POTENTIAL_PUSH_DETAIL_PATH =
  SKY_EYE_SYSTEM_PATH + '/potentialCustomers/pushDetail'
